
  // @ts-nocheck
  import { Component, Vue, Watch } from 'vue-property-decorator'
  import UserService from '@/services/auth/UserService'
  import { SessionVariablesHelper } from '@/utils/helpers'
  import { loadChatwoot, showChatwoot, resetChatwoot } from '@/modules/chatwoot'

  const sessionVariables = new SessionVariablesHelper()

  // vue-idle hooks
  Component.registerHooks(['onIdle', 'onActive'])

  @Component({
    watch: {
      $route() {
        sessionVariables.update()
      }
    },

    created() {
      sessionVariables.create()
    },
  })
  export default class App extends Vue {
    @Watch('idPlatform', { immediate: true, deep: true })
    async onidPlatform(val: any, oldVal: any) {
      if (val) {
        try {
          let users = await this.userServiceInstance.userList(val)
          this.$store.commit('SOCKET_PLATFORM_USERS', users.body)
          this.$connect(`${process.env.VUE_APP_WEBSOCKET_URL!}?Auth=${this.$auth.token()}`)
        } catch (err) {
          console.log(err)
        }
      }

      await resetChatwoot()

      if (val === 769 && this.$auth.user().profile === 'operator') {
        await loadChatwoot('uYFFgDVkPYBKNU8bCELef4Yi');
        await showChatwoot();
      }
      if (val === 771 && this.$auth.user().profile === 'operator') {
        await loadChatwoot('Tjt9JZqS5trpcEabizmAbrkG');
        await showChatwoot();
      }
    }

    private get idPlatform() {
      return this.$auth.user().id_platform
    }

    private userServiceInstance = new UserService()

    private onIdle() {
      if (
        this.$store.state.socket.isConnected &&
        this.$store.getters['exportToPABX/chunksAmount'] == 0
      ) {
        this.$disconnect()
      }
    }

    private onActive() {
      this.$connect(`${process.env.VUE_APP_WEBSOCKET_URL!}?Auth=${this.$auth.token()}`)
    }
  }
